import React from 'react'
import useSwr from 'swr'
import Wallet from '@/utils/wallet'
import axios from 'axios'
import { API_URL } from '@/utils/constants'

export const fetcher = async ([, address]: [string, string | undefined]) => {
	if (!address) {
		return []
	}

	const { data } = await axios.get(`${API_URL}/wallet/${address}/alkanes-balance`)
	if (!Array.isArray(data)) {
		throw new Error('Invalid alkanes balance response')
	}
	return data
}

export default function useAlkanesBalance(address?: string): {
	data: any[]
	isLoading: boolean
	error: unknown
	retry: () => void
} {
	const a = address || Wallet.getTaprootAddress()

	const { data, isLoading, error, mutate } = useSwr(['/alkanes-balance', a], fetcher)

	const alkanes = React.useMemo(() => {
		if (!data || !Array.isArray(data)) {
			return []
		}

		return data
	}, [data])

	return { data: alkanes, isLoading, error, retry: () => void mutate() }
}
